/**
 * Libs
 */

/**
 * Types
 */
import { TechPageHeaderVariant } from 'src/features/common/tech-pages/tech-pages.types';

/**
 * Utils
 */
import { media } from 'src/ui/common/mixins/media';
import styled, { css } from 'styled-components';

export const StyledTechPageHeader = styled.div<{ type: TechPageHeaderVariant }>`
    color: ${({ theme }) => theme.colors.white};
    margin: 0 auto;
    width: 100%;
    position: relative;

    ${({ type }) => {
        switch (type) {
            case 'monochrome':
                return css`
                    padding: 89px 10px 61px;
                    background: linear-gradient(
                        270deg,
                        rgba(${({ theme }) => theme.colors.gs500Rgb}, 0) 0%,
                        ${({ theme }) => theme.colors.gs500} 100%
                    );

                    ${media.md(css`
                        padding: 176px 0 50px;
                    `)}
                `;
            case 'faq':
                return css`
                    padding: 72px 10px 40px;
                    color: ${({ theme }) => theme.colors.warmBlack};
                    background-image: linear-gradient(to bottom, #168aad, #72a4c6, #abbfda, #daddec, #ffffff);

                    ${media.sm(css`
                        padding: 100px 40px 40px;
                    `)}

                    ${media.lg(css`
                        padding: 176px 0 50px;
                    `)}
                `;
            default:
                return '';
        }
    }}

    & > div {
        ${({ type }) =>
            type === 'monochrome' &&
            css`
                max-width: 996px;
            `}
    }

    h1 {
        margin: 0 0 4px;
    }

    p {
        ${media.sm(css`
            font-size: 16px;
            line-height: 130%;
        `)}
    }
`;

export const StyledTechPageContent = styled.div`
    padding: 40px 10px 100px;
    color: ${({ theme }) => theme.colors.white};

    ${media.lg(css`
        padding: 96px 0 144px;
    `)}

    & > div {
        max-width: 996px;
    }

    p {
        font-size: 14px;

        ${media.md(css`
            font-size: 17px;
        `)}
    }
`;
